import { DistributedBars } from '../../Common/Charts/DistributedBars';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const ProductionPermanenceDistribution = () => {
    const { chartData } = useProductionTemporalChartsDataContext();

    const distPerm = chartData?.permanenceDistribution || {};
    const subtitles = Object.keys(distPerm).sort((a, b) => {
        const startOf = (label) => parseInt(label.match(/\d+/)?.[0] ?? '0', 10);
        return startOf(a) - startOf(b);
    });
    const values = subtitles.map((label) => distPerm[label]);
    const colors = subtitles.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <DistributedBars
            title={'Distribuição dos Dias de Permanência'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
